import React, { FC } from 'react';
import styled from 'styled-components';
import { Black1, White2 } from '../styles/colours';
import { DemiBold } from '../styles/fonts';

const StyledResultsCount = styled.div`
  background: ${White2};
  padding: 2.2rem 0rem 2rem 0rem;
  font-size: 1.5rem;
  font-family: ${DemiBold};
  color: ${Black1};
`;

export const ResultsCount: FC<{ count: number; label: string }> = ({
  count,
  label,
}) => {
  return (
    <StyledResultsCount>
      {label}
      <span data-type="total-count"> ({count})</span>
    </StyledResultsCount>
  );
};
